import React, { useState } from 'react';
import { Box, Typography, TextField, Button } from '@mui/material';
import { useMytaverseEvent } from '../../../providers';
import { useStyles } from './styles';
import { useMytaverse } from '../../../../../providers/MytaverseProvider';

const MessagesTab = () => {
  const { developersTerminalMessages, setDevelopersTerminalMessages } =
    useMytaverseEvent();
  const { sendMessageToUnreal } = useMytaverse();
  const [inputMessage, setInputMessage] = useState('');
  const classes = useStyles();

  const handleSendMessage = () => {
    if (inputMessage.trim()) {
      let message;
      try {
        message = Object(inputMessage);
      } catch (e) {
        setInputMessage('Wrong syntax');
      }
      sendMessageToUnreal(message);
      const updatedMessages = [...developersTerminalMessages, inputMessage];
      setDevelopersTerminalMessages(updatedMessages);
      setInputMessage('');
    }
  };

  return (
    <Box sx={classes.root} className="no-drag">
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Type a message..."
          value={inputMessage}
          onChange={(e) => setInputMessage(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
          sx={{
            flex: 1,
            color: '#FFF',
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#FFF',
              },
              '&:hover fieldset': {
                borderColor: '#FFF',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#FFF',
              },
            },
            '& .MuiInputBase-input': {
              color: '#FFF',
            },
          }}
        />
        <Button
          variant="contained"
          onClick={handleSendMessage}
          sx={{ height: '56px' }}
        >
          Send
        </Button>
      </Box>
      <Box sx={{ flex: 1, overflowY: 'auto', mb: 2 }}>
        {developersTerminalMessages.map((message, index) => (
          <Typography key={index} sx={{ mb: 1 }}>
            {message}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};

export default MessagesTab;
